import { toast } from "react-hot-toast";
import { OFFERING_ACTIONS as TYPES } from './chatbotActionTypes';
import { apicall } from "../../../services/api";

const BASE_URL = "chatbot/offerings";

// Fetch all ChatbotOfferings
export const fetchChatbotOfferings = (update = false, page = 1, limit = 5, search = "") => async (dispatch, getState) => {
  dispatch({ type: TYPES.FETCH_REQUEST });

  if (update) {
    const existingData = getState()?.chatBotReducers?.chatbotOfferings?.data || [];
    if (existingData.length > 0) {
      dispatch({ type: TYPES.FETCH_SUCCESS, payload: existingData });
      return;
    }
  }

  try {
    const options = {
      params: {
        page,
        limit,
        search, // optional if your API supports search
      },
    };
    const res = await apicall(`${BASE_URL}`, "get", null, options, "v3");
    const ChatbotOfferingsArray = res.data?.data || [];

    dispatch({
      type: TYPES.FETCH_SUCCESS,
      payload: ChatbotOfferingsArray,
    });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_FAILURE, payload: err.message });
  }
};


// Fetch offering by ID
export const fetchOfferingById = (id) => async (dispatch) => {
  dispatch({ type: TYPES.FETCH_BY_ID_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "get", {}, {}, "v3");
    dispatch({ type: TYPES.FETCH_BY_ID_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: TYPES.FETCH_BY_ID_FAILURE, payload: err.message });
  }
};

// Add new offering
export const addOffering = (data) => async (dispatch) => {
  dispatch({ type: TYPES.ADD_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}`, "post", data, {}, "v3");
    toast.success(res?.data?.message || "Offering added successfully");
    dispatch(fetchChatbotOfferings(false));
    dispatch({ type: TYPES.ADD_SUCCESS, payload: res.data });
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to add offering");
    dispatch({ type: TYPES.ADD_FAILURE, payload: err?.response?.data });
    return err?.response;
  }
};

// Update offering
export const updateOffering = (id, data) => async (dispatch) => {
  dispatch({ type: TYPES.UPDATE_REQUEST });
  try {
    const res = await apicall(`${BASE_URL}/${id}`, "patch", data, {}, "v3");
    toast.success(res?.data?.message || "Offering updated successfully");
    dispatch(fetchChatbotOfferings(false));
  } catch (err) {
    toast.error(err?.response?.data?.message || "Failed to update offering");
    dispatch({ type: TYPES.UPDATE_FAILURE, payload: err.message });
  }
};

// Delete offering
export const deleteOffering = (id) => async (dispatch) => {
  dispatch({ type: TYPES.DELETE_REQUEST });
  try {
    await apicall(`${BASE_URL}/${id}`, "delete", {}, {}, "v3");
    toast.success("Offering deleted successfully");
    dispatch(fetchChatbotOfferings(false));
  } catch (err) {
    dispatch({ type: TYPES.DELETE_FAILURE, payload: err.message });
  }
};
